<template>
  <div class="modal-content">
    <div class="modal-body">
      <div class="row">
        <div class="col-md-12">
          <h2>{{ _('Waiting for payment') }}</h2>
          <h3 v-if="status">{{ statusText }}</h3>
          <h3 v-else>{{ _('Loading...') }}</h3>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-warning" v-on:click="abort" :disabled="!canAbort"><i class="fa fa-fw fa-ban"></i>{{ _('Abort') }}</button>
      <button type="button" class="btn btn-default hidden-xs" v-on:click="close"><i class="fa fa-close fa-fw"></i>{{ _('Close') }}</button>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import events from '~/lib/events'

export default {
  mixins: [events],
  props: ['shopId', 'amount', 'reference', 'pollUrl'],
  data () {
    return {
      status: '',
      statusText: '',
      response: null,
      pollInterval: null
    }
  },
  computed: {
    canAbort () {
      return this.status !== 'SUCCESS'
    },
  },
  methods: {
    success () {
      clearInterval(this.pollInterval)
      this.$emit('success', this.response)
    },
    close () {
      clearInterval(this.pollInterval)
      this.$emit('close', {
        errorMessage: this.status === 'ERROR' ? this.statusText : this._('Payment cancelled.')
      })
    },
    abort () {
      clearInterval(this.pollInterval)
      this.$emit('abort', {
        errorMessage: this.status === 'ERROR' ? this.statusText : this._('Payment aborted.')
      }) 
    },
    processPaymentDetails(data) {
      this.status = data.state
      if (data.state === 'CREATED') {
        this.statusText = this._('Waiting for customer...')
      }
      if (data.state === 'AUTHORIZED') {
        this.statusText = this._('Payment authorized.')
        this.success()
        return
      }
      if (data.state === 'ABORTED') {
        this.statusText = this._('Payment aborted.')
      }
      if (data.state === 'EXPIRED') {
        this.statusText = this._('Payment expired.')
      }
      if (data.state === 'TERMINATED') {
        this.statusText = this._('Payment terminated.')
      }
    }
  },
  mounted () {
    if(!this.events) {
      let events = {}
      events['mobilepayStatus'] = (message) => {
        if (message.shopId === this.shopId && message.data.reference === this.reference) {
          this.status = message.data.name
          this.processPaymentDetails({
            amount: message.data.amount,
            reference: message.data.reference,
            state: message.data.name,
          })
        }
      }
      this.events = events
    }
    this.enableEventBus()
    this.pollInterval = setInterval(async () => {
      let response
      try {
        const data = {
          method: 'Query',
          reference: this.reference
        }
        response = await axios.post(this.pollUrl, data)
      } catch (e) {
        console.log('error', e)
        return
      }
      this.response = response.data
      this.processPaymentDetails(response.data)
    }, 2000)
  }
}
</script>
